<template>
  <div>
    
    <section class="c-section c-section--home">
      <div class="o-container">
        <div class="c-inari c-inari--home">
          <img :src="`${baseUrl}img/inari.svg`" alt="INARI">
        </div>
        <div class="c-home-columns">
          <div class="c-home-column c-home-column--1">
            <main-header></main-header>
            <div class="c-arrow-down"></div>
            <p class="lead">In Japan, finding your <strong>ikigai</strong> is when you discover your true passion and reason for being.</p>
            <button class="c-button c-button--primary c-button--large c-button--start" @click.prevent="start">Begin game</button>
          </div>
          <div class="c-home-column c-home-column--2">
            <div class="c-scroll c-scroll--home c-scroll--small">
              <img class="c-scroll__top" :src="`${baseUrl}img/scroll/top.svg`" alt="">
              <div class="c-scroll__middle">
                <svg class="c-scroll__shadow c-scroll__shadow--top" width="532.4" height="81.16" preserveAspectRatio="xMinYMin meet" viewBox="0 0 532.4 81.16" role="presentation"><path fill="#cfa973" d="M532.4 0v43.72L0 81.16V0z"/></svg>
                
                <header>
                  <h2>
                    Win flights<br />
                    <span>
                      to Japan
                      <small>with</small>
                      <a href="https://www.airasia.com/en/home.page?utm_medium=display&utm_source=jnto&utm_campaign=d7_au_ptmkt%7Cjnto%7C04062018%7Cau-en" @click="$ga.event('SecretScrolls', 'Click', 'AirAsia Logo Side');" target="_blank"><img :src="`${baseUrl}img/airasia.svg`" alt="AirAsia"></a>
                    </span>
                  </h2>
                </header>

                <div class="c-arrow-down c-arrow-down--mobile"></div>
                <button class="c-button c-button--primary c-button--start" @click.prevent="start">Begin game</button>

                <div class="s-entry-content">
                  <p>Welcome old friend. I gather you are here because you heard about the Secret Scrolls of Ikigai. Remember, journeys worth taking are never easy.</p>

                  <p>In Japan, we believe that the pursuit of your true passion can lead to unthinkably wonderful things. What are they? That’s for you to find out.</p>

                  <p>Your journey to all the answers begin here. To unlock the secrets of ikigai, you must solve a series of riddles. If you are successful, you will have the chance to <strong>win return flights to Japan</strong> for you and a friend and step closer to discovering your ikigai in Japan.</p>

                  <p>Are you ready?</p>
                </div>

                <img class="c-scroll__shadow c-scroll__shadow--bottom" :src="`${baseUrl}img/scroll/shadow-bottom-japan.svg`" alt="">
              </div>
              <img class="c-scroll__bottom" :src="`${baseUrl}img/scroll/bottom.svg`" alt="">
            </div>
          </div>
        </div>
      </div>

      <div class="section-divider-arrow">
        <div class="c-arrow-down"></div>
      </div>
    </section>

  </div>
</template>

<script>
  import Icon from '@/components/Icon';
  import MainHeader from '@/components/MainHeader';

  export default {
    name: 'home',
    components: {
      Icon,
      MainHeader,
    },
    methods: {
      start() {
        this.$store.commit('setView', 'riddles');
        this.$ga.event('SecretScrolls', 'Click', 'Begin Game');
        window.scrollTo(0, 0);
      },
    },
  };
</script>



// WEBPACK FOOTER //
// Home.vue?4ea1b94c